import { jsx as e } from "react/jsx-runtime";
import { BaseTypography as o } from "../../common/components/BaseStyledComponents/BaseTypography.js";
import { useTheme as t, Skeleton as r } from "@mui/joy";
const l = ({ children: l2, loading: n, level: i = "body-xs", width: a = "80px" }) => {
  const d = t();
  return e(o, { level: i, lightColor: d.palette.neutral[500], fontWeight: 400, children: e(r, { variant: "text", loading: n, level: i, sx: { width: a, borderRadius: "8px" }, children: n ? null : l2 }) });
};
export {
  l as Label,
  l as default
};
//# sourceMappingURL=Label.js.map
